import React from "react";
import {
    ResponsiveContainer,
    AreaChart,
    Area,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
} from "recharts";

const formatCurrencyShort = (n) => {
    const num = Number(n) || 0;
    if (num >= 10000000) return `₹${(num / 10000000).toFixed(2)}Cr`;
    if (num >= 100000) return `₹${(num / 100000).toFixed(2)}L`;
    if (num >= 1000) return `₹${(num / 1000).toFixed(1)}K`;
    return `₹${num}`;
};

const pickLabel = (period) => {
    // period like "YYYY-MM-DD"
    if (!period) return "";
    const s = String(period);
    // show only DD for last 30 days compact
    const parts = s.split("-");
    return parts.length === 3 ? parts[2] : s;
};

export default function RevenueAreaChart({ data = [] }) {
    return (
        <div className="sa-rev-chart">
            <ResponsiveContainer width="100%" height="100%">
                <AreaChart data={data} margin={{ top: 8, right: 8, left: 8, bottom: 0 }}>
                    <defs>
                        {/* Gradient fill */}
                        <linearGradient id="revFill" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="currentColor" stopOpacity={0.35} />
                            <stop offset="85%" stopColor="currentColor" stopOpacity={0.02} />
                        </linearGradient>
                    </defs>

                    {/* <CartesianGrid strokeDasharray="3 3" vertical={false} opacity={0.25} /> */}

                    <XAxis
                        dataKey="period"
                        tickFormatter={pickLabel}
                        tickMargin={10}
                        minTickGap={24}
                        axisLine={false}
                        tickLine={false}
                    />


                    <YAxis hide domain={[0, "auto"]} />


                    <Tooltip
                        formatter={(value) => [`₹${Number(value || 0).toLocaleString("en-IN")}`, "Revenue"]}
                        labelFormatter={(label) => `Date: ${label}`}
                    />

                    <Area
                        type="monotone"
                        dataKey="amount"
                        stroke="currentColor"
                        strokeWidth={2}
                        fill="url(#revFill)"
                        dot={false}
                        activeDot={false}
                    />

                </AreaChart>
            </ResponsiveContainer>
        </div>
    );
}
